module.exports = __webpack_public_path__ + "static/media/centro_cancha_1.6d6be5a0.jpg";